<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                This is a reusable multi-select component.<br/>
                It's designed as a combination chip-wagon + select<br/>


                <chip-select
                    v-model="show_chip_select"
                    :valuelist="valuelist"
                    :selection.sync="selections"
                />
            </v-card-text>

        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";
import ChipSelect from "@/Generic/ChipSelect";

export default {
    name: "ExampleChipSelect",
    components: {
        ChipSelect,
        AppLayout,
        SmartTable
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
            show_chip_select: true,
            valuelist: [],
            selections: [],
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        doSomething() {
            console.log("Something!")
        },
        fetchData() {
            axios.post(route('examplefiles.list').url()).then((result)=>{
                this.$set(this, 'valuelist', result?.data?.data)
            })
        }
    },
}
</script>

<style>

</style>
